import { Body } from 'components/Text/Body';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import { VideoThumbnailPlayer } from 'components/VideoThumbnailPlayer';
import { CmsApiVideoBlockData } from 'modules/cms/api/types/blocks/CmsApiVideoBlock';

type Props = {
  blockIndex: number;
  data: CmsApiVideoBlockData;
  fullWidthLayout?: boolean;
};

export function CmsVideoBlock({
  blockIndex,
  data: { headline, subtitle, videoUrl },
  fullWidthLayout,
}: Props) {
  return (
    <div>
      {(headline || subtitle) && (
        <div style={{ marginBottom: 48 }}>
          {headline && (
            <RichTextHeadline textAlignCenter={fullWidthLayout}>
              {headline}
            </RichTextHeadline>
          )}
          {subtitle && (
            <Body
              analyticsData={{
                eventName: 'CMS Block',
                eventProperties: {
                  block_position: blockIndex,
                  block_type: 'Video',
                },
              }}
              textAlign={fullWidthLayout ? 'center' : 'left'}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </div>
      )}

      <div style={{ aspectRatio: '1280 / 720', lineHeight: 0 }}>
        <VideoThumbnailPlayer
          videoUrl={videoUrl}
          size={{ type: 'expand' }}
          largePlayButton
          thumbnailQaId="cms-embed-video"
        />
      </div>
    </div>
  );
}
